import InteractiveModel from './InteractiveModel'

export default InteractiveModel
